var _path, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07508 14.3805C8.12269 14.5032 8.19408 14.6152 8.28516 14.7103L13.2872 19.7062C13.3805 19.7993 13.4913 19.8732 13.6131 19.9236C13.735 19.974 13.8656 20 13.9975 20C14.2639 20 14.5194 19.8943 14.7078 19.7062C14.8011 19.613 14.8751 19.5024 14.9256 19.3807C14.9761 19.2589 15.002 19.1285 15.002 18.9967C15.002 18.7307 14.8962 18.4755 14.7078 18.2873L11.4065 15L18.9996 15C19.2649 15 19.5194 14.8948 19.707 14.7074C19.8946 14.52 20 14.2659 20 14.0009C20 13.7359 19.8946 13.4817 19.707 13.2943C19.5194 13.1069 19.2649 13.0017 18.9996 13.0017L11.4065 13.0017L14.7078 9.71438C14.8016 9.6215 14.876 9.51099 14.9268 9.38923C14.9776 9.26747 15.0038 9.13687 15.0038 9.00497C15.0038 8.87307 14.9776 8.74247 14.9268 8.62071C14.876 8.49895 14.8016 8.38844 14.7078 8.29556C14.6148 8.2019 14.5042 8.12757 14.3823 8.07684C14.2604 8.02612 14.1296 8 13.9975 8C13.8655 8 13.7347 8.02612 13.6128 8.07684C13.4909 8.12757 13.3802 8.2019 13.2872 8.29556L8.28516 13.2914C8.19409 13.3865 8.12269 13.4985 8.07508 13.6212C7.97502 13.8644 7.97502 14.1373 8.07508 14.3805Z",
    fill: "url(#paint0_linear_5402_102718)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 26,
    rx: 13,
    stroke: "url(#paint1_linear_5402_102718)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5402_102718",
    x1: 12.1305,
    y1: 17,
    x2: 20.366,
    y2: 15.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5402_102718",
    x1: 9.63768,
    y1: 21,
    x2: 28.854,
    y2: 18.0834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/BackButton.a6b978874a18668f2d01afdb86d346bd.svg";
export { ForwardRef as ReactComponent };